import * as React from 'react';
import {connect} from 'react-redux';
import {Card} from "antd";
import {Comment} from '@models/comment';
import TableRenderer from "@hocs/TableRenderer";
import CommentsTable from "@components/comments/Table";
import {fetchRequest, updateRequest} from '@actions/comment';
import SearchCommentsComponent from "@components/comments/Search";
import {ApplicationState, ConnectedReduxProps} from '@reducers/index';

interface PropsFromState {
    loading: boolean
    data: Comment[]
    errors?: string,
    count: number
}

interface PropsFromDispatch {
    fetchRequest: typeof fetchRequest,
    updateRequest: typeof updateRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps

class CommentsIndexPage extends React.Component<AllProps> {
    render() {
        const {loading, data, search, currentPage, updateRequest} = this.props;
        return (
            <div className={'page-table-wrapper'}>
                <Card className={`page-table-header search-part`} bordered={false}>
                    <SearchCommentsComponent search={search}/>
                </Card>
                <CommentsTable data={data}
                               currentPage={currentPage}
                               rowKey={record => record.id}
                               updateRequest={updateRequest}
                               loading={loading}/>
            </div>
        )
    }
}

const mapStateToProps = ({comments}: ApplicationState) => ({
    loading: comments.loading,
    errors: comments.errors,
    data: comments.data,
    count: comments.count
});

const mapDispatchToProps = {
    fetchRequest,
    updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(CommentsIndexPage));

